import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
} from "reactstrap";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import moment from "moment";
import { CircularProgress } from "@material-ui/core";
import { FaCloudUploadAlt } from "react-icons/fa";
import Select from "react-select";

const AddReferFriendWidget = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [position, setPosition] = useState(1);
  const [title, setTitle] = useState();
  const [description, setDescription] = useState();
  const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [neverEnding, setNeverEnding] = useState(false);
  const [publishDate, setPublishDate] = useState("");
  const [unPublishDate, setUnPublishDate] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
  }, []);

  const handleSubmit = () => {
    if (!position) {
      setErrorMessage("Please enter position");
      setErrorAlert(true);
      return;
    }
    if (!title) {
      setErrorMessage("Please enter title");
      setErrorAlert(true);
      return;
    }
    if (!description) {
      setErrorMessage("Please enter description");
      setErrorAlert(true);
      return;
    }
    if (selectedFiles.length < 1) {
      setErrorMessage("Please select image");
      setErrorAlert(true);
      return;
    }
    if (publishDate === "Invalid date" || !publishDate) {
      setErrorMessage("Please select publish date");
      setErrorAlert(true);
      return;
    }
    if (!neverEnding) {
      if (unPublishDate === "Invalid date" || !unPublishDate) {
        setErrorMessage("Please select unpublish date");
        setErrorAlert(true);
        return;
      }
      if (unPublishDate < publishDate) {
        setErrorMessage("Unpublish date should be after the publish date");
        setErrorAlert(true);
        return;
      }
    }

    setLoader(true);

    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("sort_order", position);
    formdata.append("title", title);
    formdata.append("description", description);
    formdata.append("type", "app");
    formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    formdata.append("version", 18);
    formdata.append("status", status);
    formdata.append("publish_date", publishDate);
    formdata.append("unpublish_date", neverEnding ? "" : unPublishDate);
    formdata.append("created_datetime", currentDate);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/referfriendwidgets`,
      requestOptions
    )
      .then((response) => {
        if (response.status === 201) {
          setSuccesAlert(true);
          setLoader(false);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
  const validateFileSize = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      var image = new Image();
      image.src = e.target.result;
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (width !== 70 || height !== 70) {
          setErrorMessage("Height and Width must be 70X70px");
          setErrorAlert(true);
        } else {
          handleAcceptedFiles(file);
        }
      };
    };
  };
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path === "PNG" || path === "png") {
      setSelectedFiles(files);
    } else {
      setErrorMessage("Please select a .png file");
      setErrorAlert(true);
    }
  }

  const renderSuccessAlert = () => (
    <SweetAlert
      title="Success!"
      success
      confirmBtnBsStyle="success"
      beforeUnmount={() => {
        props?.history.push("/refer-friend-widgets");
      }}
      onConfirm={() => {
        props?.history.push("/refer-friend-widgets");
        setSuccesAlert(false);
        setLoader(false);
      }}
      onCancel={() => setSuccesAlert(false)}
    >
      {"Refer a Friend Widget Added Successfully"}
    </SweetAlert>
  );

  const renderFailureAlert = () => (
    <SweetAlert
      title="Warning!"
      warning
      confirmBtnBsStyle="warning"
      onConfirm={() => {
        setErrorAlert(false);
        setLoader(false);
      }}
    >
      {errorMessage ? errorMessage : "Error. Something went wrong."}
    </SweetAlert>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Add Refer a Friend Widget" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <input
                                type="number"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => setPosition(e.target.value)}
                                defaultValue={position}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => setTitle(e.target.value)}
                                defaultValue={title}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <textarea
                                rows={3}
                                col={20}
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => setDescription(e.target.value)}
                                defaultValue={description}
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            <Card>
                              <CardBody>
                                <Form>
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      validateFileSize(acceptedFiles);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div className="dropzone">
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted" />
                                          </div>
                                          <h4>
                                            Drop files here or click to upload.
                                          </h4>
                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            Image should be 70X70px in png
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => (
                                      <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                      >
                                        <div className="p-2">
                                          <Row className="align-items-center">
                                            <Col className="col-auto">
                                              <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                              />
                                            </Col>
                                            <Col>
                                              <Link
                                                to="#"
                                                className="text-muted font-weight-bold"
                                              >
                                                {f.name}
                                              </Link>
                                              <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                              </p>
                                            </Col>
                                          </Row>
                                        </div>
                                      </Card>
                                    ))}
                                  </div>
                                </Form>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => setNeverEnding(!neverEnding)}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => setStatus(e.value)}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status === "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/refer-friend-widgets");
                        }}
                        color="danger"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{
                          color: "#ffffff",
                          width: "80px",
                          marginLeft: "10px",
                        }}
                        className="btn btn-success"
                        onClick={() => handleSubmit()}
                        type="button"
                      >
                        {loader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddReferFriendWidget;
